module.exports = __webpack_public_path__ + "static/img/7.e21d125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-mercancias-especifico/7.png
// module id = QEU7
// module chunks = 0